import {makeStyles} from "@material-ui/core/styles";

export const useSelectAllRowStyles = makeStyles(() => ({
    root: {
        cursor: 'inherit'
    },
    typography: {
        marginRight: '0.5em'
    }
}));
